export default function ChatwootAgentCheckIcon({ className = '' }) {
  return (
    <span className={`crm-cw-agent-check ${className}`.trim()} aria-hidden="true">
      <span className="crm-cw-agent-check__ring" />
      <svg className="crm-cw-agent-check__svg" viewBox="0 0 20 20" fill="none">
        <path
          d="M5.5 10.2 8.4 13.1 14.5 7"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
